import getColor from "@insite/mobius/utilities/getColor";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import getProp from "@insite/mobius/utilities/getProp";

import { css } from "styled-components";

export const inputStyles = (hasError?: boolean, height?: string) => {
    const inputBorderColor = "#b6b9bb"; // Styleguide uses an unique color not in the theme
    if (typeof height === "undefined") {
        height = "50px";
    }
    if (typeof hasError === "undefined") {
        hasError = false;
    }
    return css`
        height: ${height};
        background: ${getColor("common.background")};
        border: 1px solid ${hasError ? getColor("danger.main") : inputBorderColor};
        border-radius: 0;
        border-width: 1px !important;
        color: ${({ theme }) => getContrastColor("common.background", theme)};
        padding-left: 10px;
        &[data-committed="true"] {
            color: ${getColor("text.main")};
        }
        &[aria-invalid="true"] {
            border: 1px solid ${getColor("danger.main")};
        }
        &:hover,
        &:focus {
            outline: none;
            box-shadow: 0 0 0 3px rgba(116, 164, 248, 0.2);
        }
        &:hover {
            color: ${getColor("text.main")};
            border: 1px solid ${getColor("common.backgroundContrast")};
        }
        &:focus,
        &[aria-expanded="true"] {
            color: ${getColor("text.main")};
            border: 1px solid ${getProp("theme.focus.color")};
        }
        &:disabled {
            background: ${getColor("common.disabled")};
            cursor: not-allowed;
            color: ${getColor("text.disabled")};
            &:hover {
                border: 1px solid ${inputBorderColor};
            }
        }
        padding-right: 75px;
        text-overflow: ellipsis;
    `;
};

export const labelStyles = () => {
    return css`
        margin-bottom: 10px;
        font-size: 20px;
        font-weight: 600;
        letter-spacing: 0.57px;
        line-height: 24px;
        color: ${getColor("danger.main")};
        > span {
            color: ${getColor("text.main")};
        }
        > span[data-required="true"]:after {
            content: "*";
            color: ${getColor("danger.main")};
            margin-left: 5px;
        }
    `;
};

export const radioButtonStyle = () => {
    return css`
        & + label::before {
            border: 1px solid ${getColor("common.border")};
        }
        &:hover:not(:disabled) + label::before {
            box-shadow: 0 0 0 2px rgba(116, 164, 248, 0.2);
            border: 1px solid ${getColor("common.backgroundContrast")};
        }
        &:checked:not(:disabled) + label::before {
            border: 1px solid ${getColor("common.accentContrast")};
            background: white;
        }
        &:checked + label::after {
            background: ${getColor("common.accentContrast")};
        }
        &:focus:not(:disabled) + label::before {
            box-shadow: 0 0 0 2px rgba(116, 164, 248, 0.2);
            border: 1px solid ${getProp("theme.focus.color")};
        }
    `;
};
